export enum PaymentMethods {
  BankTransfer = 'bank_transfer',
  CreditCard = 'credit_card',
  Paypal = 'paypal',
  Skrill = 'skrill',
}
